var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myAdvice"},[_c('v-input',{attrs:{"type":"textarea","placeholder":"请输入意见","maxlength":300},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}}),_c('div',{staticClass:"footer",on:{"click":_vm.submitAdvice}},[_vm._v("提交")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }